import portalRoutes from './portalRoutes';
import nestedRoutes from './nestedRoutes';

let updatedRoutes = portalRoutes;
const routes = [...updatedRoutes, ...nestedRoutes];

export default routes;
